import { useState } from "react";
import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { useSite } from "../../context/SiteContext";
import { waLink } from "../../lib/api";
import { hasConsent, loadAnalytics } from "../../lib/analytics";

export function WhatsAppFloat({ message }) {
  const { site } = useSite();
  const wa = site?.whatsapp || {};
  return (
    <a href={waLink(wa.number, message || wa.default_message)} target="_blank" rel="noopener noreferrer" aria-label="Chat on WhatsApp" data-testid="whatsapp-float"
      className="fixed bottom-5 right-5 z-40 h-14 w-14 rounded-full bg-black text-white border-2 border-white shadow-lg flex items-center justify-center hover:bg-white hover:text-black hover:border-black transition-colors">
      <MessageCircle className="h-6 w-6" />
    </a>
  );
}

export function ConsentBanner() {
  const { site } = useSite();
  const [state, setState] = useState(localStorage.getItem("cookie_consent"));
  const a = site?.analytics || {};
  if (state || (!a.ga4_id && !a.gtm_id) || a.require_consent === false) return null;
  const choose = (v) => {
    localStorage.setItem("cookie_consent", v);
    setState(v);
    if (v === "granted" && hasConsent()) loadAnalytics(a);
  };
  return (
    <div className="fixed bottom-0 inset-x-0 z-50 bg-white border-t border-black p-4" data-testid="consent-banner">
      <div className="container-x flex flex-col sm:flex-row gap-3 items-start sm:items-center justify-between text-sm">
        <p>We use analytics cookies to understand how the site is used. <Link to="/privacy-policy" className="underline">Privacy Policy</Link></p>
        <div className="flex gap-2">
          <button className="btn-secondary btn-sm" onClick={() => choose("denied")} data-testid="consent-decline">Decline</button>
          <button className="btn-primary btn-sm" onClick={() => choose("granted")} data-testid="consent-accept">Accept</button>
        </div>
      </div>
    </div>
  );
}
